export default class VideoModal {
    constructor() {

        const htmlModal = `
            <div class="modal-video modal-video-id">
                <div class="backshadow"></div>
                <div class="modal-content">
                    <div class="block-video">
                        <div class="close-modal">
                            <span>&#10005;</span>
                        </div>
                        <iframe src="" width="960" height="685" title="YouTube video player" allow="autoplay; encrypted-media; picture-in-picture;" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        `
        document.body.insertAdjacentHTML('beforeend', htmlModal)

        let elVideoModal = document.querySelector('.modal-video')
        let iframe = elVideoModal.querySelector('iframe')
        let elCloseModal = elVideoModal.querySelectorAll('.backshadow, .close-modal')

        const callsVideoModal = document.querySelectorAll('[data-videoid]');
        callsVideoModal.forEach(el => {
            let dataVideoid = el.dataset.videoid;
            if (dataVideoid.startsWith('https://youtu.be/') && !dataVideoid.startsWith('https://youtu.be/watch?v=')) {
                let videoCode = dataVideoid.replace('https://youtu.be/', '');
                dataVideoid = `https://youtu.be/watch?v=${videoCode}`;
            } else if (dataVideoid.startsWith('https://www.youtube.com/')) {
                if (dataVideoid.startsWith('https://www.youtube.com/embed/')) {
                    if (dataVideoid.includes('?')) {
                        dataVideoid += '&autoplay=1';
                    } else {
                        dataVideoid += '?autoplay=1';
                    }
                } else if (!dataVideoid.startsWith('https://www.youtube.com/watch?v=')) {
                    let videoCode = dataVideoid.replace('https://www.youtube.com/', '');
                    dataVideoid = `https://www.youtube.com/watch?v=${videoCode}`;
                }
            } else if (!/^(https?:\/\/)[^\s/$.?#].[^\s]*$/i.test(dataVideoid)) {
                dataVideoid = `https://www.youtube.com/embed/${dataVideoid}?autoplay=1&mute=1`;
          }
            el.setAttribute('data-videoid', dataVideoid);
        })
        callsVideoModal.forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault()
                let videoid = this.dataset.videoid
                const videomobileid = this.dataset.videomobileid;

                if (window.innerWidth < 1024 && videomobileid) {
                    videoid = videomobileid;
                    elVideoModal.classList.add('mobile')
                }
                iframe.src = videoid
                elVideoModal.classList.add('show')
                document.body.classList.add('no-scroll')
            })
        })

        elCloseModal.forEach(el => {
            el.addEventListener('click', function (event) {
                event.preventDefault()
                elVideoModal.classList.remove('show')
                document.body.classList.remove('no-scroll')
                iframe.src = ''
                iframe.classList.remove = "shorts"
                elVideoModal.classList.remove('mobile')
            })
        })

    }
}
new VideoModal();